// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1OrbB","list":"styles_list__2eOpD"};